module.exports = __webpack_public_path__ + "img/logo.1d6be5b2.png";